import RestAPIUtils from '../react-core-lib/rest-api/rest-api-utils';

class PartnerApi {
    static PARTNER_API_CONFIG = {
        apiUrl: process.env.REACT_APP_PARTNER_API_URL,
    };

    static async getPublicClinicData(linkId) {
        const apiPath = `/v1/patient/public-clinic-data`;
        const params = { linkId };
        return RestAPIUtils.makeGetRequestNoAuth(PartnerApi.PARTNER_API_CONFIG, apiPath, params);
    }
}

export default PartnerApi;
